/* global axios */
import ApiClient from './ApiClient';

export class BoardsAPI extends ApiClient {
  constructor() {
    super('boards', { accountScoped: true });
  }

  findByTeam(teamId) {
    return axios.get(`${this.url}`, { params: { team_id: teamId } });
  }
}

export default new BoardsAPI();
